import { OnInit, Component, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ChartService } from '../../services/chart.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { Router } from '@angular/router';
import { PopUIEngineComponent } from '../../../pop-uiengine/pop-uiengine.component';
import { DialogModalSize } from '../../../dialog/dialog-ref';
import { DialogService } from '../../../dialog/dialog.service';
import _moment from 'proxies/dayjs';
import { StorageService } from 'src/modules/base/shared/services/storage.service';

@Component({
    selector: 'app-chart-doughnut',
    templateUrl: './chart-doughnut.component.html',
    styleUrls: ['./chart-doughnut.component.scss'],
    standalone: false
})
export class ChartDoughnutComponent implements OnInit {
  @ViewChild('canvasChartE', { read: ElementRef }) canvasChart;
  @Input() item: any; //object conatining the json def of the widget
  @Input() data: any;
  @Input() selection: any; // elementref where selected widget will be shown
  @Input() chartOptions: any;
  @Input() chartColours: any;
  @Input() chartLegend: any;
  @Input() hideLabels: any;
  @Output() configChanged: EventEmitter<any> = new EventEmitter();
  moment = _moment;
  @ViewChild('kxChart') kxChart: any;
  filterType = 'fixed';
  datasets: any;
  labels: any;
  timePeriodList: any;
  intervals: string[];
  showWidgets: boolean;
  config: any = {isCached:false};
  constructor(
    private baseService: BaseService,
    private chartService: ChartService,
    private appService: AppService, 
    private loader: LoaderService,
    public router: Router,
    public dialogService:DialogService,
    public storage: StorageService,
  ) {

  }

  ngOnInit() {
    this.chartService.getTimePeriod((timePeriodList)=>{
      this.timePeriodList = timePeriodList;
    });
  }

  loadChartData() {
    this.loader.showSpinner()
    this.showWidgets = false;
    this.data = this.chartService.prepareChartPayload(this.filterType,this.data);
    this.chartService.loadChartData(this.data, (response) => {
        if (response.chartData == undefined)
          response.chartData = []
        response = this.handleEmptyData(response);
        this.labels = response.chartLabels;
        this.datasets = response.chartData;
        if(response.chartLabels  != undefined && response.chartLabels.length>10){
          this.chartOptions["legend"]["display"] = false;
        }else{
          this.chartOptions["legend"]["display"] = true;
        }
        if(response.isCached != undefined){
          this.config.isCached  = response.isCached
        }else{
          this.config.isCached = false;
        }
      this.showWidgets = true;
      this.loader.hideSpinner()
    })

  }

  getData(){
    if(this.filterType == 'fixed'){
      this.configChanged.emit({config:{interval:this.data.interval}})
      this.loadChartData();
    }
  }

  ngAfterViewInit() {
    this.chartService.getWidget(this.data,(res)=>{
      this.data = res.data;
      res.chartOptions.onClick =  (evt, array) => {
        this.chartOnClick(evt,array);
      };
      this.chartOptions = res.chartOptions;
      this.getIntervalList();
    });
  }

  makeFullScreen(fullScreen) {
    if(!fullScreen &&  this.labels.length <= 5){
      //if dataset length is less than 5 then label should always be visible
      fullScreen = true;
    }else if(!fullScreen &&  this.labels.length > 30){
      //if dataset length is less than 5 then label should never be visible
      fullScreen = false;
    }
    this.chartOptions["legend"]["display"] = fullScreen;
    this.chartOptions = {... this.chartOptions};
  }

  handleEmptyData(response) {
    if (response.chartData != undefined && response.chartData.length > 0) {
      for (let singleData of response.chartData) {
        if (singleData.data != undefined && singleData.data.length > 0) {
          //if all datasets are 0 add -1 to the chart so that some value will  show, in label and tooltip we will revert back the value to 0
          if (singleData.data.reduce((a, b) => a + b, 0) == 0) {
            singleData.data = singleData.data.map(x => -1);
            if (singleData.backgroundColor != undefined && singleData.backgroundColor.length > 0) {
              singleData.tempColor = JSON.parse(JSON.stringify(singleData.backgroundColor));
              singleData.backgroundColor = singleData.backgroundColor.map(x => 'grey');
            }
          }
        }
      }
    }
    return response;
  }
  setFilter(event) {
    console.log('eventis', event)
    this.data.time_period = event.target.value;
    this.configChanged.emit({config:{time_period:this.data.time_period}})
    this.getIntervalList();
  }
  setInterval(event) {
    console.log('eventis', event)
    this.data.interval = event.target.value;
    this.configChanged.emit({config:{interval:this.data.interval}})
    this.loadChartData();
  }
  getIntervalList() {
    this.intervals = this.chartService.getIntervalList(this.data);
    if (!this.intervals.includes(this.data.interval)){
      this.data.interval = this.intervals[this.intervals.length - 1]
    } 
    this.loadChartData()
  }

  public chartOnClick(evt: any,array:any): void {
    this.data.filterType = this.filterType;
    this.chartService.chartClick(evt,array,this.kxChart,this.data,"");
   }

   valueChange(e,q){
    console.log(e,q,'e,q')
    this.data.from = e.FROM;
    this.data.to = e.TO;
    if(this.data.from!=null && this.data.to!=null){
      this.data.from = this.moment(this.data.from).format("YYYY-MM-DD");  
      this.data.to = this.moment(this.data.to).format("YYYY-MM-DD"); 
      this.loadChartData();
    }
   
  }

  refreshData(){
    var key = this.chartService.getChartKey(this.data);
    this.storage.removeData(key,()=>{
      this.loadChartData();
    })
  }

}